import React, { useState } from "react";
import { Badge } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import ImagePreview from "../../ticket/sub-screen/image-preview/ImagePreview";
import { getSaleStatus, getReturnStatus } from "../helpers/sale-status";

export const TableRow = (props) => {
  const {
    id,
    channel,
    channelName,
    numbers,
    amount,
    inputAmount,
    soldAmount,
    resultDate,
    createdAt,
    images,
    returnedAmount,
    isExpired,
    status,
    isSelected,
    onSelect,
    createdByName,
    approvedByName,
  } = props;
  const [showImagePreview, setShowImagePreview] = useState(false);

  const datedString = moment(createdAt || "").format("DD/MM HH:mm");
  const displayChannel = channelName || channel;
  // Only active tickets with remaining stock can still be returned.
  const canBeReturned =
    Number(status) === 1 &&
    Number(amount) > 0 &&
    (!returnedAmount || returnedAmount < inputAmount);

  const returnStatus = getReturnStatus({ returnedAmount, inputAmount });
  const saleStatus = getSaleStatus({ status, amount, isExpired });

  const imageSrc =
    images && typeof images === "string"
      ? images.startsWith("http")
        ? images
        : `data:image/jpeg;base64,${images}`
      : null;

  return (
    <tr className={`align-middle ${isSelected ? "bg-light-yellow" : ""}`}>
      <td className="text-center py-3" onClick={(e) => e.stopPropagation()}>
        <div className="form-check d-flex justify-content-center">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isSelected}
            disabled={!canBeReturned}
            onChange={(e) => onSelect && onSelect(id, e.target.checked)}
            style={{
              cursor: canBeReturned ? "pointer" : "not-allowed",
              transform: "scale(1.2)",
            }}
          />
        </div>
      </td>

      <td
        className="text-start fw-bold text-primary small"
        style={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={(e) => {
          e.stopPropagation();
          props.onShowDetail && props.onShowDetail(props);
        }}
      >
        #{id}
      </td>

      <td className="text-center">
        <Badge bg="info" className="px-3 py-2 fw-normal">
          Vé đơn
        </Badge>
      </td>

      <td className="text-start">
        <div className="d-flex align-items-center gap-2">
          {props.channelLogo && (
            <img
              src={props.channelLogo}
              alt={displayChannel}
              className="rounded-circle border"
              style={{ width: "36px", height: "36px", objectFit: "cover" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
          <div className="text-start">
            <div className="fw-bolder text-dark">{displayChannel}</div>
            <div className="small text-muted">{resultDate}</div>
          </div>
        </div>
      </td>

      <td className="text-center">
        <Badge
          bg=""
          className="fs-6 font-monospace bg-light text-dark border border-gray-200 px-3 py-2"
          style={{ letterSpacing: "2px" }}
        >
          {(numbers || "").split("").join(" ")}
        </Badge>
      </td>

      <td className="text-center">
        <span className="fw-bold text-primary">
          {new Intl.NumberFormat("vi-VN").format(inputAmount || 0)}
        </span>
      </td>

      <td className="text-center">
        <span className="fw-bold text-success">
          {new Intl.NumberFormat("vi-VN").format(soldAmount || 0)}
        </span>
      </td>

      <td className="text-center">
        <span
          className={`fw-bold ${isExpired && amount > 0 ? "text-danger" : "text-warning"}`}
        >
          {new Intl.NumberFormat("vi-VN").format(amount || 0)}
        </span>
      </td>

      <td className="text-center">
        <span className="fw-bold text-danger">
          {new Intl.NumberFormat("vi-VN").format(returnedAmount || 0)}
        </span>
      </td>

      <td className="text-center">
        <div className="d-flex flex-column align-items-center gap-1">
          <Badge bg={saleStatus.variant} className="px-3 py-2 fw-normal">
            {saleStatus.text}
          </Badge>
          {!isExpired && (saleStatus.text === "Đang bán" || saleStatus.text === "Hết vé") && (
            <span className="text-muted small">
              Còn {new Intl.NumberFormat("vi-VN").format(amount || 0)} vé
            </span>
          )}
        </div>
      </td>

      <td className="text-center">
        <Badge bg={returnStatus.variant} className="px-3 py-2 fw-normal">
          {returnStatus.text}
        </Badge>
      </td>

      <td className="text-center">
        {imageSrc ? (
          <div
            className="d-inline-block rounded overflow-hidden shadow-sm position-relative"
            style={{ width: "32px", height: "32px", cursor: "pointer" }}
            onClick={() => setShowImagePreview(true)}
          >
            <img
              src={imageSrc}
              alt="Ticket"
              className="w-100 h-100 object-fit-cover"
            />
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-black bg-opacity-10 hover-overlay">
              <FontAwesomeIcon
                icon={faImages}
                className="text-white small"
                style={{ fontSize: "10px" }}
              />
            </div>
          </div>
        ) : (
          <span className="text-muted small">-</span>
        )}
      </td>

      <td className="text-center text-muted small">{datedString}</td>

      <td className="text-center">
        {createdByName ? (
          <span className="small text-dark">{createdByName}</span>
        ) : (
          <span className="text-muted small">-</span>
        )}
      </td>

      <td className="text-center">
        {approvedByName ? (
          <span className="small text-success">{approvedByName}</span>
        ) : (
          <span className="text-muted small">-</span>
        )}
      </td>

      <ImagePreview
        show={showImagePreview}
        onHide={() => setShowImagePreview(false)}
        image={images}
        title={`Vé số: ${numbers}`}
      />
    </tr>
  );
};
